import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "@/i18n/I18nContext";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const NewsletterForm = () => {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();
    const nextErrors = {};
    if (!name.trim()) nextErrors.name = t("home.newsletter.errors.nameRequired");
    if (!email.trim()) {
      nextErrors.email = t("home.newsletter.errors.emailRequired");
    } else if (!emailRegex.test(email.trim())) {
      nextErrors.email = t("home.newsletter.errors.emailInvalid");
    }
    if (Object.keys(nextErrors).length > 0) {
      setErrors(nextErrors);
      return;
    }
    setErrors({});
    navigate("/thank_you");
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="grid gap-4 sm:grid-cols-2"
      noValidate
      data-testid="newsletter-form"
    >
      <div className="sm:col-span-1">
        <label
          htmlFor="newsletter-name"
          className="block text-sm font-medium text-[#0F2C59]"
        >
          {t("home.newsletter.form.nameLabel")}
        </label>
        <input
          id="newsletter-name"
          name="name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder={t("home.newsletter.form.namePlaceholder")}
          className="mt-1 w-full rounded-md border border-[#CBD5E1] bg-white px-3 py-2 text-[#0F172A] placeholder:text-[#94A3B8] focus:border-[#0D7A5F] focus:outline-none focus:ring-2 focus:ring-[#0D7A5F]/30"
          data-testid="newsletter-name-input"
        />
        {errors.name && (
          <p className="mt-1 text-xs text-red-700" data-testid="newsletter-name-error">
            {errors.name}
          </p>
        )}
      </div>
      <div className="sm:col-span-1">
        <label
          htmlFor="newsletter-email"
          className="block text-sm font-medium text-[#0F2C59]"
        >
          {t("home.newsletter.form.emailLabel")}
        </label>
        <input
          id="newsletter-email"
          name="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={t("home.newsletter.form.emailPlaceholder")}
          className="mt-1 w-full rounded-md border border-[#CBD5E1] bg-white px-3 py-2 text-[#0F172A] placeholder:text-[#94A3B8] focus:border-[#0D7A5F] focus:outline-none focus:ring-2 focus:ring-[#0D7A5F]/30"
          data-testid="newsletter-email-input"
        />
        {errors.email && (
          <p className="mt-1 text-xs text-red-700" data-testid="newsletter-email-error">
            {errors.email}
          </p>
        )}
      </div>
      <div className="sm:col-span-2">
        <button
          type="submit"
          className="inline-flex w-full items-center justify-center rounded-md bg-[#0D7A5F] px-5 py-3 text-sm font-semibold text-white hover:bg-[#0B6B53] sm:w-auto"
          data-testid="newsletter-submit"
        >
          {t("home.newsletter.form.submit")}
        </button>
        <p className="mt-3 text-xs text-[#64748B]">
          {t("home.newsletter.form.consent")}
        </p>
      </div>
    </form>
  );
};

export default NewsletterForm;
